import { initialState as importState } from 'store/import/import';
import { initialState as exploreData } from 'store/explore/data';
import { initialState as exploreLoading } from 'store/explore/loading';
import { initialState as exploreMap } from 'store/explore/map';
import { initialState as exploreShapesData } from 'store/explore/shapesData';
import { initialState as exploreViews } from 'store/explore/views';
import { initialState as exploreProspects } from 'store/explore/prospects';
import { initialState as propertyUWState } from 'store/underwrite/propertyUW';
import { initialState as auctionUWState } from 'store/underwrite/auctionUW';
import { initialState as channelWorkflowState } from 'store/underwrite/channelWorkflow';
import { initialState as queueState } from 'store/queue';
import { initialState as clientTxnOppsState } from 'store/clientTxnOpps';
import { initialState as appState } from 'store/app';
import { initialState as adminState } from 'store/admin';
import { initialState as searchState } from 'store/search';
import { initialState as dashboardState } from 'store/dashboard';
import { initialState as opportunityHistoryState } from 'store/underwrite/opportunityHistory';
import { initialState as assumptionModulesState } from 'store/assumptions/assumptionModules';
import { initialState as assumptionGroupsState } from 'store/assumptions/assumptionGroups';
import { initialState as assumptionGridState } from 'store/assumptions/assumptionGrid';
import { initialState as assumptionMapState } from 'store/assumptions/assumptionMap';
import { initialState as postAcqUWState } from 'store/postAcq/postAcqUW';
import { initialState as postAcqWorkflowState } from 'store/postAcq/postAcqWorkflow';

export const initialState = {
  // General app management
  appState,
  adminState,

  selectedTask: null,

  clientTxnOppsState,
  channelWorkflowState,
  propertyUWState,
  auctionUWState,
  queueState,
  importState,
  searchState,

  // EXPLORE
  exploreData,
  exploreShapesData,
  exploreMap,
  exploreLoading,
  exploreProspects,
  exploreViews,

  // DASHBOARD
  dashboardState,

  // ASSUMPTIONS
  assumptionModulesState,
  assumptionGroupsState,
  assumptionGridState,
  assumptionMapState,

  opportunityHistoryState,

  // POST ACQ
  postAcqUWState,
  postAcqWorkflowState
};
